import { render, staticRenderFns } from "./TermosDeUso.vue?vue&type=template&id=4ae43b64"
import script from "./TermosDeUso.vue?vue&type=script&lang=js"
export * from "./TermosDeUso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports